const assetHierarchyFunctions = (hierarchyLevels, hierarchy, onPropertyChange, rights) => {
  const getHierarchyLevelDataSource = level => {
    if (!hierarchy.loaded) return [];

    const _level = hierarchy[level];
    return _level ? _level.data : [];
  };

  const getHierarchyItem = () => {
    const sortedHierarchyLevels = [...hierarchyLevels].sort((a, b) => (a.level > b.level ? 1 : -1));
    return sortedHierarchyLevels.find(z => z.level !== 0);
  };

  const checkIfControlIsDisabled = () => {
    return rights.readOnlyFull || !rights.financedAssetWrite;
  };

  const onLevelChange = (levelData, level, label, triggers) => {
    if (levelData === null) {
      //is delete
      levelData = { id: null, name: null };
    }
    onPropertyChange("hierarchyLevel", { ...levelData, level, label, triggers });
  };

  return {
    getHierarchyLevelDataSource,
    getHierarchyItem,
    checkIfControlIsDisabled,
    onLevelChange
  };
};

export default assetHierarchyFunctions;
